import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as classNames from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import * as Media from "react-media";
import { WithContext as ReactTags } from 'react-tag-input';
import { publishedData } from './data';

@withRouter
export class NavItem extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            showSubMenu: false,
            forceHide: false
        };

        this.onHideMenu = this.onHideMenu.bind(this);
        this.onForceHideMenu = this.onForceHideMenu.bind(this);
        this.onShowMenu = this.onShowMenu.bind(this);
        this.onMenuToggle = this.onMenuToggle.bind(this);
    }

    componentDidMount() {
        //this.setState({
        //   showSubMenu: this.props.to === '/Publications'
        //})
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location !== prevProps.location) {
            this.setState({ forceHide: false });
        }
    }

    onMenuToggle() {
        if (this.state.showSubMenu || this.props.items.length == 0) {
            let url = this.props.to + (this.props.hash ? this.props.hash : "");
            this.props.history.push(url);
        }

        if (this.props.items.length > 0) {
            this.setState({ showSubMenu: !this.state.showSubMenu });
        }

    }

    onHideMenu(to, hash, event) {

        let url = to + (hash ? hash : "");
        this.props.history.push(url);

        if (this.state.showSubMenu) {
            this.setState({ showSubMenu: false });
        }
        event.stopPropagation();
    }

    onForceHideMenu(forceHide, event) {
        //console.log('onShowMenu', forceHide, this.state.showSubMenu);
        if (this.state.showSubMenu) {
            this.setState({ showSubMenu: false, forceHide: forceHide });
        }
    }

    onShowMenu(forceShow) {
        //console.log('onShowMenu', forceShow, this.state.showSubMenu);
        if (!this.state.showSubMenu && (forceShow || !this.state.forceHide)) {
            this.setState({ showSubMenu: true });
        }
    }

    render() {
        const { to, hash, location, children, items, lastItem, ...props } = this.props;
        let active = location.pathname === to || items.filter(i => i.route === location.pathname).length > 0;
        let self = this;

        let menuHeight = this.state.showSubMenu ? `${items.length * 35}px` : "0px";
        let menuItemHeight = this.state.showSubMenu ? "35px" : "0px";

        let subMenuItems = items.map((item, index) => {
            return <Media key={"li" + item.name + index} query="(max-width: 992px)">
                {
                    matches => {
                        const hash = item.hash || '';
                        const subItemActive = location.pathname === item.route && location.hash === hash;
                        return matches ? (
                            <li onTouchStart={this.onHideMenu.bind(this, item.route, item.hash)}
                                className={classNames({ "active": subItemActive })}
                                style={{ width: '100%', height: menuItemHeight }} >
                                <Link to={{ pathname: item.route, hash: item.hash }}>
                                    {item.name}
                                    <span className="pull-right py-1 small" >&#8594;</span>
                                </Link>
                            </li>
                        ) : (<li className={classNames({ "active": subItemActive })}
                            onClick={event => self.onForceHideMenu(true, event)}
                            style={{ width: '100%', height: menuItemHeight }} >
                            <Link to={{ pathname: item.route, hash: item.hash }}>
                               {item.name}
                                <span className="pull-right py-1 small " >&#8594;</span>
                            </Link>
                        </li>
                        )
                    }
                }
            </Media>
        });

        let displayMenu = items.length > 0 && this.state.showSubMenu ? <div className="nav-submenu-wrapper">
            <ul className="px-3 py-3"  style={{ maxWidth: "325px", backgroundColor: "#f1f1f1" }}>
                {subMenuItems}
            </ul>
        </div> : undefined;

        let menu = <Media query="(max-width: 1023px)">
            {
                matches => {
                    return matches ? (
                        <li role="presentation" className={classNames('nav-item main-menu ', { "active": active })} style={{ cursor: "pointer" }}
                            onTouchStart={self.onMenuToggle.bind(this)}>
                            <span className="nav-link-header ">
                                <span>{children}</span>
                            </span>

                            {displayMenu}
                        </li>
                    ) : (<li role="presentation"
                        className={classNames('nav-item main-menu ', { "active": active })}
                        onMouseOver={self.onShowMenu.bind(this, false)}
                        onMouseLeave={self.onForceHideMenu.bind(this, false)}
                            onClick={event => {
                                //console.log("clicked")
                                self.onForceHideMenu(false, event);
                            }}>
                        <Link
                            to={{ pathname: to, hash: hash }}
                            onClick={self.onShowMenu.bind(this, true)}
                            className="nav-link-header"><span>{children}</span></Link>
                        {displayMenu}
                    </li>
                    )
                }
            }
        </Media>;

        return (menu)
    }
}

@withRouter
export class NewsItem extends React.Component<any, any> {

    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let hash = this.props.location.hash;
        if (hash) {
            const domElement = ReactDOM.findDOMNode(this.refs[hash.replace('#', '')]);
            if (domElement) {
                domElement.scrollIntoView(false);
            }
        }
    }

    render() {
        const { id, location, children, title, subtitle, date, text, caption, img, link, anchor, ...props } = this.props;

        let hash = this.props.location.hash;
        if (hash) {
            hash = hash.replace('#', '');
        }
        let externalLink = link ? <a className="px-2" target="_blank" href={link}><strong><u>Read more</u></strong></a> : undefined;

        let newsAnchor = anchor ? anchor : id.toString();

        let itemCss = `row  ${hash === newsAnchor ? "" : ""}`;
        let localLink = `${window.location.href}#${newsAnchor}`;
        return (
            <div className={itemCss}>
                <a ref={newsAnchor} id={newsAnchor} className="anchor-detail" />
                <div className="col-12 ">
                    <div className="container news-item">

                        <div className="row">
                            <div className="col-12 col-sm-8 mt-3 mt-sm-0">
                                <span className="text-muted py-1">{date}</span>

                                <div className="news-header py-2" >{title}</div>
                                <div className="news-subheader my-1" >{subtitle}</div>
                            </div>
                            <div className="col-12 col-sm-4">
                                <div className="text-right news-subheader">
                                    <ul className="news-links">
                                        <li>
                                            <a href={`mailto:?subject=${title}&body=${localLink}`} ><i className="fa fa-envelope" aria-hidden="true"></i></a>
                                        </li>
                                        <li>
                                            <a target="_blank" href={`http://twitter.com/intent/tweet?text=${title}%20${encodeURIComponent(localLink)}`}><i className="fa fa-twitter " aria-hidden="true"></i></a>
                                        </li>
                                        <li>
                                            <a target="_blank" href={`http://www.facebook.com/sharer.php?u=${encodeURIComponent(localLink)}&t=${title}`}><i className="fa fa-facebook" aria-hidden="true"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-8 mt-3 mt-sm-0">
                                <span dangerouslySetInnerHTML={{ __html: text }}></span>
                                {externalLink}
                            </div>
                            <div className="col-12 col-sm-4">
                                <img src={img} />
                                <div className="text-muted small mt-1">
                                    {caption}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="my-4" />
                </div>
            </div>
        )
    }
}


@withRouter
export class NewsItemSummary extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = { showDetail: false };
    }
    render() {
        const { location, children, title, date, text, caption, img, link, anchor, ...props } = this.props;


        let styles = `col-12 col-md-4 mt-4 news-item-summary clickable`;
        return (
            <div className={styles}>
                <a href={`/News#${anchor}`}>
                    <div className="news-sub-header brown-bg text-middle" style={{ width: "100%", height: "100%" }}>
                        <div className="mx-4">
                            <div className="text-muted">{date}</div>
                            <div>{title}</div>
                        </div>
                    </div>
                    <img src={img} title={title} style={{ width: "100%" }} />
                </a>
            </div>
        )
    }
}
//onMouseOver={this.onImgHover.bind(this, true)} onMouseOut={this.onImgHover.bind(this, false)}

@withRouter
export class PeopleItem extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }
    componentDidMount() {
        let hash = this.props.location.hash;
        if (hash) {
            const domElement = ReactDOM.findDOMNode(this.refs[hash.replace('#', '')]);
            if (domElement) {
                domElement.scrollIntoView();
            }
        }
    }
    render() {
        const { to, location, children, title, text, subtitle, anchor, anchorName, link, ...props } = this.props;
        let img = this.props.img;
        let subtitleRender = subtitle ? <h6>{subtitle}</h6> : undefined;
        if (!img || img.length == 0) {
            img = "./images/Unconfirmed.png";
        }
        //let anchorValue = anchorName ? anchor : "";
        let externalLink = link ? <p><a className="emphasis-link" target="_blank" href={link}><u>Read more</u></a></p> : undefined;
        return (
            <div className="row pt-3 pb-3 hover-person">
                <div className="col-12">
                    <div className="container news-item">
                        <div className="row">
                            <div className="col-12 col-md-4">
                                <img src={img} />
                            </div>
                            <div className="col-12 col-md-8 mt-3 mt-sm-0">
                                <a id={anchorName} ref={anchorName} className="anchor-detail" />
                                <h4>{title}</h4>
                                {subtitleRender}
                                <p className="mt-3">{text}</p>
                                {externalLink}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

@withRouter
export class KeyPartnerItem extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }




    render() {
        const { location, children, title, link, img, ...props } = this.props;


        return (
            <div className="col col-6 col-md-3 mt-3 text-center">
                <a href={link} target="_blank"><img src={img} alt={title} style={{ "maxWidth": "100%" }} /></a>
            </div>
        )
    }
}

@withRouter
export class ResourceItem extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        const { id, title, publishedby, year, link, directLink, ...props } = this.props;

        var pub = publishedData.find(p => p.anchor === id);
        var activeLink = directLink ? pub.link : link;
        var target = directLink ? "_blank" : "_parent";

        return (
            <div className="published-item row py-3" >
                <div className="col col-12 col-md-6">
                    <Link to={activeLink} target={target}><strong>{title}</strong></Link>
                </div>
                <div className="col col-7 col-md-4">
                    {publishedby}
                </div>
                <div className="col col-3 col-md-1">
                    {year}
                </div>
                <div className="col col-2 col-md-1">
                    <Link to={activeLink} target={target}><span className="fa fa-plus fa-lg text-right"></span></Link>
                </div>
            </div>
        )
    }
}




@withRouter
export class FocusBadge extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        const { location, children, name, theme, ...props } = this.props;

        let badgeTheme = `alert alert-${theme}`;
        return (<div>
            <span className="alert">{name}</span>
            <span className="">{name}</span>
        </div>
        )
    }
}

@withRouter
export class AustraliaMap extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        const { location, children, states, activeCss, disabledCss, ...props } = this.props;

        let stateWA = states.find((item) => item === "WA") ? activeCss : disabledCss;
        let stateNSW = states.find((item) => item === "NSW") ? activeCss : disabledCss;
        let stateQLD = states.find((item) => item === "QLD") ? activeCss : disabledCss;
        let stateSA = states.find((item) => item === "SA") ? activeCss : disabledCss;
        let stateTAS = states.find((item) => item === "TAS") ? activeCss : disabledCss;
        let stateACT = states.find((item) => item === "ACT") ? activeCss : disabledCss;
        let stateNT = states.find((item) => item === "NT") ? activeCss : disabledCss;
        let stateVIC = states.find((item) => item === "VIC") ? activeCss : disabledCss;

        return (
            <svg className="australia" viewBox="0 0 166.07 152.91">
                <polygon id="wa" className={stateWA} points="33.34 37.07 1.94 57.83 0 69.98 14.63 101.61 14.63 114.08 26.25 116.45 32.27 108.92 45.17 108.92 47.97 102.9 65.82 96.87 61.52 18.79 47.97 14.92 33.34 37.07" />
                <polygon id="sa" className={stateSA} points="114.44 72.24 114.44 126.24 109.71 122.15 108.2 115.48 103.47 109.46 98.31 112.47 101.96 99.24 94.43 110.96 87.77 99.24 78.08 96.77 67.55 96.77 65.82 70.74 114.44 72.24" />
                <polygon id="nt" className={stateNT} points="102.39 23.73 102.61 70.56 65.39 69.12 63.24 18.57 65.39 18.57 67.11 19.65 67.11 17.5 65.39 14.91 69.27 8.03 72.92 5.45 76.8 5.45 76.8 1.58 83.03 3.52 89.27 5.45 91.27 6.74 95.94 5.45 98.52 6.74 91.27 17.5 102.39 23.73" />
                <polygon id="qld" className={stateQLD} points="125.63 0 121.03 6.31 119.03 26.39 113.58 30.69 103.83 24.09 104.11 70.56 115.59 70.56 115.59 83.46 148.28 85.47 166.07 83.75 166.07 73.14 158.32 60.81 157.17 55.65 153.73 55.65 148.28 44.17 140.54 38.44 136.81 18.36 131.94 16.35 125.63 0" />
                <polygon id="nsw" className={stateNSW} points="148.28 86.78 115.45 85.02 115.45 107.03 119.17 107.03 127.49 116.49 140.68 117.89 141.87 122.62 148.43 125.41 148.43 116.49 160.19 104.52 160.19 100.06 163.91 100.06 166.06 85.01 148.28 86.78" />
                <polygon id="vic" className={stateVIC} points="148.28 126.24 139.95 127.53 134.03 130 134.03 132.15 128.3 130 128.3 127.53 123.71 130.97 117.39 127.53 115.39 127.53 115.67 108.31 119.19 108.31 127.36 117.92 139.95 119.46 141.45 123.98 148.28 126.24" />
                <polygon id="tas" className={stateTAS} points="125.43 143.23 128.22 146.03 126.5 146.03 128.22 150.76 131.02 152.91 134.03 150.76 136.18 150.76 136.18 146.67 137.15 147.32 137.9 141.51 136.4 140.22 134.03 141.51 131.02 141.51 125.43 138.93 125.43 143.23" />
                <polygon id="act" className={stateACT} points="142.75 117.45 145.76 116.08 145.76 111.66 142.75 111.66 142.75 117.45" />
            </svg>
        )
    }
}




// WEBPACK FOOTER //
// ./src/shared.tsx